import React, { useEffect } from "react";
import { Container } from "reactstrap";
import { PageHeader } from "../../../../CommonElements/PageTitle";
import { Stack } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { Tabs } from "antd";
import CampaignStatementReport from "./CampaignStatementReport";
import GroupStatementReport from "./GroupStatementReport";
import {
  MADINAH_PERMISSIONS_FULL_NAMES,
  MAKKAH_PERMISSIONS_FULL_NAMES,
} from "@/utils/constants";
import PermissionGate from "@/CommonElements/PermissionGate";
import { useSystem } from "@/utils/hooks/useLocation";
import { SYSTEMS } from "@/utils/permissions";

const UpcomingGroupsAndCampaignsDetailsReport = () => {
  const { t } = useTranslation();
  const { currentSystem } = useSystem();
  const [searchParams, setSearchParams] = useSearchParams();
  const permissions =
    currentSystem === SYSTEMS.madina
      ? MADINAH_PERMISSIONS_FULL_NAMES
      : MAKKAH_PERMISSIONS_FULL_NAMES;

  // Get current tab from URL, default to 'campaigns'
  const currentTab = searchParams.get("tab") || "campaigns";

  // Set default tab if not present in URL
  useEffect(() => {
    if (!searchParams.get("tab")) {
      setSearchParams({ tab: "campaigns" }, { replace: true });
    }
  }, [searchParams, setSearchParams]);

  const handleTabChange = (key) => {
    setSearchParams({ tab: key });
  };

  const tabItems = [
    {
      key: "campaigns",
      label: t("CAMPAIGNS") || "Campaigns",
      children: (
        <PermissionGate permission={permissions.view_export_campaign_statement_report}>
          <CampaignStatementReport />
        </PermissionGate>
      ),
    },
    {
      key: "groups",
      label: t("GROUPS") || "Groups",
      children: (
        <PermissionGate permission={permissions.view_export_group_statement_report}>
          <GroupStatementReport />
        </PermissionGate>
      ),
    },
  ];

  return (
    <Stack gap={3}>
      <PageHeader title={t("CAMPAIGNS_AND_GROUPS_STATEMENT_REPORT")} sticky={false} />
      <Container fluid>
        <Tabs activeKey={currentTab} items={tabItems} onChange={handleTabChange} className="mb-3" />
      </Container>
    </Stack>
  );
};

export default UpcomingGroupsAndCampaignsDetailsReport;
